// const workerURL = new URL('/service-worker.js', location.origin)

export const initServiceWorker = async (): Promise<unknown> => {
    try {
        if (!('serviceWorker' in navigator)) {
            return
        }

        // Remove old service workers
        const registrations = await navigator.serviceWorker.getRegistrations()
        registrations.forEach((registration) => registration.unregister())

        // Do not cache files on DEV
        if (import.meta.env.DEV) {
            return
        }

        // At this point we register Service Worker in all environments
        // Then we need to register SW only for PROD

        // Disable caching for now. Will be updated with offline mode.
        // await navigator.serviceWorker.register(workerURL.href)
    } catch (error) {
        console.error('Service Worker registration failed:', error)
    }
}
